import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { Controller } from 'react-hook-form';
import FormHelperText from '@mui/material/FormHelperText';
import { CommonDropDownStyle } from '../../ui/styled';

const DropdownFormInput = (props) => {
  const {
    name,
    control,
    label,
    options,
    defaultId,
    errors,
    helperText,
    disabled,
    register,
    complianceCategory,
    complianceDescription,
    orgCity,
    sascsRegion,
    region,
  } = props;

  const generateSingleOptions = () => {
    return options?.map((item, index) => {
      return (
        <MenuItem
          key={index}
          value={
            complianceCategory
              ? item.cplTypId
              : complianceDescription
              ? item.cplTypId
              : region
              ? item.sscId
              : item.id
          }
        >
          {!orgCity && !sascsRegion && !region && item.value}
          {complianceCategory && item.cplTypCat}
          {complianceDescription && item.cplTypDsc}
          {orgCity && item.id}
          {sascsRegion && item.sascaRegion}
          {region && item.region}
        </MenuItem>
      );
    });
  };

  return (
    <CommonDropDownStyle>
      <InputLabel>{label}</InputLabel>
      <Controller
        register={register}
        render={({ field: { onChange, value } }) => (
          <Select
            defaultValue={defaultId}
            onChange={onChange}
            value={value}
            error={errors}
            disabled={disabled}
          >
            {generateSingleOptions()}
          </Select>
        )}
        control={control}
        name={name}
      />
      <FormHelperText style={{ color: '#ff4d4f' }}>{helperText}</FormHelperText>
    </CommonDropDownStyle>
  );
};

export default DropdownFormInput;
